import type { MyFeedbackItem, FeedbackStatus as Status } from "@esi/shared";
import { cn } from "@/lib/utils";
import { t } from "../i18n/i18n.ts";

/**
 * A report's status as a quiet dot and word (DESIGN.md: status is never a pill). Colour only
 * where it is a state: green once fixed; every other status is neutral.
 */
export function FeedbackStatus(props: {
  report: Pick<MyFeedbackItem, "status" | "fixedIn">;
  className?: string;
}) {
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 text-xs text-fg-secondary", props.className)}
    >
      <span
        aria-hidden="true"
        className={cn("size-1.5 shrink-0 rounded-full", DOT[props.report.status])}
      />
      {statusLabel(props.report)}
    </span>
  );
}

const DOT: Record<Status, string> = {
  new: "bg-fg-muted",
  triaged: "bg-fg-muted",
  planned: "bg-fg-secondary",
  fixed: "bg-success-fg",
  not_planned: "bg-line-strong",
  duplicate: "bg-line-strong",
};

/** The status as the reporter reads it: "Fixed in version …" when the version is known. */
export function statusLabel(report: Pick<MyFeedbackItem, "status" | "fixedIn">): string {
  return report.status === "fixed" && report.fixedIn
    ? t("myFeedback.fixedIn", { version: report.fixedIn })
    : t(`myFeedback.statuses.${report.status}`);
}
